var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageWrapper", {
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: _vm.getIsMobile ? 24 : 12 } },
                  [
                    _c("h2", { staticStyle: { "text-align": "center" } }, [
                      _vm._v("需方"),
                    ]),
                    _c(
                      "el-form",
                      {
                        ref: "needFormRef",
                        staticClass: "company-info_form",
                        attrs: {
                          "label-position": _vm.getIsMobile ? "top" : "right",
                          model: _vm.needForm,
                          "label-width": "120px",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "单位名称", prop: "dscompany" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入单位名称" },
                              nativeOn: {
                                click: function ($event) {
                                  _vm.dialog = true
                                },
                              },
                              model: {
                                value: _vm.needForm.dscompany,
                                callback: function ($$v) {
                                  _vm.$set(_vm.needForm, "dscompany", $$v)
                                },
                                expression: "needForm.dscompany",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "委托代理人", prop: "dslxr" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入委托代理人" },
                              model: {
                                value: _vm.needForm.dslxr,
                                callback: function ($$v) {
                                  _vm.$set(_vm.needForm, "dslxr", $$v)
                                },
                                expression: "needForm.dslxr",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "联系电话", prop: "dstel" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入联系电话" },
                              model: {
                                value: _vm.needForm.dstel,
                                callback: function ($$v) {
                                  _vm.$set(_vm.needForm, "dstel", $$v)
                                },
                                expression: "needForm.dstel",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "传真", prop: "dsmax" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入传真" },
                              model: {
                                value: _vm.needForm.dsmax,
                                callback: function ($$v) {
                                  _vm.$set(_vm.needForm, "dsmax", $$v)
                                },
                                expression: "needForm.dsmax",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "开户银行", prop: "dsbank" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入开户银行" },
                              model: {
                                value: _vm.needForm.dsbank,
                                callback: function ($$v) {
                                  _vm.$set(_vm.needForm, "dsbank", $$v)
                                },
                                expression: "needForm.dsbank",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "账号", prop: "dsbanknum" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入账号" },
                              model: {
                                value: _vm.needForm.dsbanknum,
                                callback: function ($$v) {
                                  _vm.$set(_vm.needForm, "dsbanknum", $$v)
                                },
                                expression: "needForm.dsbanknum",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "税号", prop: "dsshuihao" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入税号" },
                              model: {
                                value: _vm.needForm.dsshuihao,
                                callback: function ($$v) {
                                  _vm.$set(_vm.needForm, "dsshuihao", $$v)
                                },
                                expression: "needForm.dsshuihao",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.getIsMobile ? 24 : 12 } },
                  [
                    _c("h2", { staticStyle: { "text-align": "center" } }, [
                      _vm._v("供方"),
                    ]),
                    _c(
                      "el-form",
                      {
                        ref: "offeringFormRef",
                        staticClass: "company-info_form",
                        attrs: {
                          "label-position": _vm.getIsMobile ? "top" : "right",
                          model: _vm.offeringsForm,
                          "label-width": "120px",
                        },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "单位名称", prop: "" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入单位名称" },
                              model: {
                                value: _vm.offeringsForm.cname,
                                callback: function ($$v) {
                                  _vm.$set(_vm.offeringsForm, "cname", $$v)
                                },
                                expression: "offeringsForm.cname",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "委托代理人", prop: "" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入委托代理人" },
                              model: {
                                value: _vm.offeringsForm.rname,
                                callback: function ($$v) {
                                  _vm.$set(_vm.offeringsForm, "rname", $$v)
                                },
                                expression: "offeringsForm.rname",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "联系电话", prop: "" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入联系电话" },
                              model: {
                                value: _vm.offeringsForm.tel,
                                callback: function ($$v) {
                                  _vm.$set(_vm.offeringsForm, "tel", $$v)
                                },
                                expression: "offeringsForm.tel",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "传真", prop: "" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入传真" },
                              model: {
                                value: _vm.offeringsForm.max,
                                callback: function ($$v) {
                                  _vm.$set(_vm.offeringsForm, "max", $$v)
                                },
                                expression: "offeringsForm.max",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "开户银行", prop: "" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入开户银行" },
                              model: {
                                value: _vm.offeringsForm.bank,
                                callback: function ($$v) {
                                  _vm.$set(_vm.offeringsForm, "bank", $$v)
                                },
                                expression: "offeringsForm.bank",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "账号", prop: "" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入账号" },
                              model: {
                                value: _vm.offeringsForm.banknum,
                                callback: function ($$v) {
                                  _vm.$set(_vm.offeringsForm, "banknum", $$v)
                                },
                                expression: "offeringsForm.banknum",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "税号", prop: "" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入税号" },
                              model: {
                                value: _vm.offeringsForm.shuihao,
                                callback: function ($$v) {
                                  _vm.$set(_vm.offeringsForm, "shuihao", $$v)
                                },
                                expression: "offeringsForm.shuihao",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c("el-button", { on: { click: _vm.handleReset } }, [
                  _vm._v("重 置"),
                ]),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleSubmit },
                  },
                  [_vm._v("生成合同")]
                ),
              ],
              1
            ),
            _vm.dialog
              ? _c(
                  "el-dialog",
                  {
                    attrs: {
                      visible: _vm.dialog,
                      title: "选择报价公司",
                      width: _vm.getIsMobile ? "100%" : "50%",
                      "append-to-body": true,
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.dialog = $event
                      },
                    },
                  },
                  [
                    _c("Company", {
                      on: { selectedCompany: _vm.getSelectedCompany },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c("Model", {
              ref: "modelRef",
              attrs: { contractContent: _vm.editorContent },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }